import Answer, { Color } from "../../model/answer";

export function setAnswerState(
    setState: React.Dispatch<React.SetStateAction<Answer>>, color: Color, player: string, playerVal: boolean): void {
    setState((state) => ({ ...state, color: color, [player]: playerVal }));
}
